import React from 'react';
import { OLD_PRICE, PRICE } from '../data/judo';
// Static info bar. No countdown or timers.
export function InfoBar() {
  return <div className="w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-183" data-mp="2finwpliybgr3">
      <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-medium sm:text-sm" data-id="element-184" data-mp="2jietq6z2mt42">
        Cena wprowadzająca {PRICE} <s className="opacity-60" data-id="element-185" data-mp="2ok45jou4bat7">{OLD_PRICE}</s> · Jednorazowa płatność · 7 dni gwarancji
      </p>
    </div>;
}